export default {
  button: {
    contact: 'Contact',
    goback: 'Go back',
    login: 'Login',
    logout: 'Logout'
  },

  form: {
    login: {
      id: 'Identifier',
      password: 'Password'
    }
  },

  label: {
    contact: {
      mail: 'Send mail',
      phone_bank: 'Call the service center'
    }
  },

  title: {
    brand: 'Template',
    contact: 'Contact',
    main: 'PWA'
  }
}
